var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "toggle",
        ..._vm.variantClassList,
        _vm.disabled && "is-disabled",
        _vm.checked && "is-selected"
      ],
      attrs: { disabled: _vm.disabled }
    },
    [
      _vm.labelText
        ? _c("Label", {
            staticClass: "toggle__label",
            attrs: { labelText: _vm.labelText, forElementId: _vm.uid },
            scopedSlots: _vm._u(
              [
                {
                  key: "leading",
                  fn: function() {
                    return [_vm._t("beforeLabel")]
                  },
                  proxy: true
                },
                {
                  key: "trailing",
                  fn: function() {
                    return [_vm._t("afterLabel")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        : _vm._e(),
      _c("div", { staticClass: "toggle__body" }, [
        _c("div", { staticClass: "toggle__input-container" }, [
          _vm.actionSaved || _vm.errorText
            ? _c(
                "span",
                { staticClass: "toggle__tooltip" },
                [
                  _c(
                    "Tooltip",
                    {
                      attrs: {
                        visible: _vm.actionSaved && _vm.errorText.length === 0
                      }
                    },
                    [_vm._v(" " + _vm._s("Change Saved") + " ")]
                  ),
                  _c(
                    "Tooltip",
                    {
                      ref: "errorTooltip",
                      attrs: {
                        visible: _vm.errorText.length > 0,
                        state: "negative"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.errorText) + " ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isChecked,
                expression: "isChecked"
              }
            ],
            staticClass: "toggle__input",
            attrs: {
              type: "checkbox",
              name: "toggle",
              id: _vm.uid,
              "aria-label": _vm.ariaLabel
            },
            domProps: {
              checked: Array.isArray(_vm.isChecked)
                ? _vm._i(_vm.isChecked, null) > -1
                : _vm.isChecked
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.isChecked,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isChecked = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isChecked = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isChecked = $$c
                  }
                },
                _vm.onChange
              ]
            }
          }),
          (_vm.insideLabelOption === 1 || _vm.insideLabelOption === 2) &&
          !_vm.checked
            ? _c(
                "span",
                {
                  ref: "insideLabelOffSpan",
                  class: [
                    "toggle__inside-label-off",
                    `is-option-${_vm.insideLabelOption}`
                  ]
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.insideLabelOptions[_vm.insideLabelOption - 1][0]
                      ) +
                      " "
                  )
                ]
              )
            : _vm._e(),
          (_vm.insideLabelOption === 1 || _vm.insideLabelOption === 2) &&
          _vm.checked
            ? _c(
                "span",
                {
                  ref: "insideLabelOnSpan",
                  class: [
                    "toggle__inside-label-on",
                    `is-option-${_vm.insideLabelOption}`
                  ]
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.insideLabelOptions[_vm.insideLabelOption - 1][1]
                      ) +
                      " "
                  )
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm.helpText
        ? _c("HelpFeedback", {
            staticClass: "toggle__help-feedback",
            attrs: { div: "", helpText: _vm.helpText }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }